import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * The publisher site's browser bar — hamburger, an inert search pill and a
 * magnifier. Every Display mobile placement sits on the same generic page, so
 * the bar is shared and pinned in the mobile frame's `frameTop` slot.
 */
@Component({
  selector: 'app-display-browser-chrome',
  standalone: true,
  templateUrl: './display-browser-chrome.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './display-browser-chrome.component.scss',
})
export class DisplayBrowserChromeComponent {}
